import styled from 'styled-components';

type TextProps = {
	children: string;
	color?: string;
	size?: number;
	weight?: number;
	type?: string;
	italic?: boolean;
};

const StyledText = styled.p<TextProps>`
	color: ${({ color, theme }) => color || theme.colors.text.main};
	font-size: ${({ size }) => size || 1}rem;
	font-weight: ${({ weight }) => weight || 500};
	font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
	margin: 0;
	line-height: ${({ size }) => (size ? (size >= 2.5 ? 1 : 1.6) : 1.6)}em;
`;

const StyledPrimaryText = styled(StyledText)`
	color: ${({ theme }) => theme.colors.main};
`;

const StyledTextLink = styled(StyledText)`
	&:hover {
		color: ${({ theme }) => theme.colors.main};
		cursor: pointer;
	}
`;

const Text = ({ children, color, size, type, weight, italic }: TextProps) => {
	if (type === 'link') {
		return (
			<StyledTextLink color={color} size={size} weight={weight}>
				{children}
			</StyledTextLink>
		);
	}
	if (color === 'primary') {
		return (
			<StyledPrimaryText color={color} size={size} weight={weight}>
				{children}
			</StyledPrimaryText>
		);
	}
	return (
		<StyledText color={color} size={size} weight={weight} italic={italic}>
			{children}
		</StyledText>
	);
};

export default Text;
